export const button = (
    <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M73.1 21.5H12.9C8.17005 21.5 4.30005 25.37 4.30005 30.1V55.9C4.30005 60.63 8.17005 64.5 12.9 64.5H73.1C77.83 64.5 81.7 60.63 81.7 55.9V30.1C81.7 25.37 77.83 21.5 73.1 21.5ZM77.4 51.6C77.4 54.18 75.68 55.9 73.1 55.9H12.9C10.32 55.9 8.60005 54.18 8.60005 51.6V30.1C8.60005 27.52 10.32 25.8 12.9 25.8H73.1C75.68 25.8 77.4 27.52 77.4 30.1V51.6Z" fill="url(#paint0_linear_2_4573)"/>
        <defs>
            <linearGradient id="paint0_linear_2_4573" x1="-23.2914" y1="30.4583" x2="98.5419" y2="50.1667" gradientUnits="userSpaceOnUse">
                <stop stopColor="#18D2EB"/>
                <stop offset="1" stopColor="#9D33DE"/>
            </linearGradient>
        </defs>
    </svg>
);

export const table = (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2_4262)">
            <path d="M26.624 25.856H38.144V37.376H43.776V25.856H55.296V20.48H43.776V8.96H38.144V20.48H26.624V25.856ZM0 71.68V0H81.92V71.68H0ZM30.72 61.44H51.2V46.08H30.72V61.44ZM5.12 61.44H25.6V46.08H5.12V61.44V61.44ZM76.8 5.12H5.12V41.216H76.8V5.12ZM76.8 46.08H56.32V61.44H76.8V46.08Z" fill="url(#paint0_linear_2_4262)"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_2_4262" x1="-31.6667" y1="-5" x2="108.333" y2="35" gradientUnits="userSpaceOnUse">
                <stop stopColor="#18D2EB"/>
                <stop offset="1" stopColor="#9D33DE"/>
            </linearGradient>
            <clipPath id="clip0_2_4262">
                <rect width="80" height="80" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

export const productTable = (
    <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M77.4 73.1V12.9H8.59998V73.1H77.4ZM68.8 30.1H17.2V21.5H68.8V30.1ZM38.7 47.3H17.2V38.7H38.7V47.3ZM68.8 47.3H47.3V38.7H68.8V47.3ZM38.7 64.5H17.2V55.9H38.7V64.5ZM68.8 64.5H47.3V55.9H68.8V64.5Z" fill="url(#paint0_linear_2_4454)"/>
        <defs>
            <linearGradient id="paint0_linear_2_4454" x1="120.042" y1="-10.7499" x2="-30.4584" y2="87.7918" gradientUnits="userSpaceOnUse">
                <stop stopColor="#9D33DE"/>
                <stop offset="1" stopColor="#18D2EB"/>
            </linearGradient>
        </defs>
    </svg>
);

export const product = (
    <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M81.7 68.8V12.9C81.7 10.535 79.765 8.59998 77.4 8.59998H12.9C10.535 8.59998 8.59998 10.535 8.59998 12.9V68.8C8.59998 71.165 10.535 73.1 12.9 73.1H77.4C79.765 73.1 81.7 71.165 81.7 68.8ZM17.2 17.2H73.1V34.4H17.2V17.2ZM21.5 21.5V30.1H34.4V21.5H21.5ZM38.7 21.5V30.1H51.6V21.5H38.7ZM55.9 21.5V30.1H68.8V21.5H55.9ZM19.35 43C20.554 43 21.5 43.946 21.5 45.15C21.5 46.354 20.554 47.3 19.35 47.3C18.146 47.3 17.2 46.354 17.2 45.15C17.2 43.946 18.146 43 19.35 43ZM25.8 43H43V47.3H25.8V43ZM51.6 43H73.1V64.5H51.6V43ZM19.35 51.6C20.554 51.6 21.5 52.546 21.5 53.75C21.5 54.954 20.554 55.9 19.35 55.9C18.146 55.9 17.2 54.954 17.2 53.75C17.2 52.546 18.146 51.6 19.35 51.6ZM25.8 51.6H43V55.9H25.8V51.6ZM55.9 51.6V60.2H68.8V51.6H55.9ZM19.35 60.2C20.554 60.2 21.5 61.146 21.5 62.35C21.5 63.554 20.554 64.5 19.35 64.5C18.146 64.5 17.2 63.554 17.2 62.35C17.2 61.146 18.146 60.2 19.35 60.2ZM25.8 60.2H43V64.5H25.8V60.2Z" fill="url(#paint0_linear_2_4243)"/>
        <defs>
            <linearGradient id="paint0_linear_2_4243" x1="109.292" y1="-7.16678" x2="-53.7501" y2="129" gradientUnits="userSpaceOnUse">
                <stop stopColor="#9D33DE"/>
                <stop offset="1" stopColor="#18D2EB"/>
            </linearGradient>
        </defs>
    </svg>
);

export const cta1 = (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M68 16H12C7.6 16 4 19.6 4 24V56C4 60.4 7.6 64 12 64H68C72.4 64 76 60.4 76 56V24C76 19.6 72.4 16 68 16ZM40 48H12V24H40V48ZM56 42L50 48L56 54V60L44 48L56 36V42ZM60 60V54L66 48L60 42V36L72 48L60 60ZM36 44V34L28.8 40L24 36.8L16 44H36ZM18.4 34.4C20.8 34.4 22.4 32.8 22.4 30.4C22.4 28 20.8 26.4 18.4 26.4C16 26.4 14.4 28 14.4 30.4C14.4 32.8 16 34.4 18.4 34.4Z" fill="url(#paint0_linear_2_4474)"/>
        <defs>
            <linearGradient id="paint0_linear_2_4474" x1="96.6666" y1="3.41172e-05" x2="-36.6667" y2="96.6667" gradientUnits="userSpaceOnUse">
                <stop stopColor="#9D33DE"/>
                <stop offset="1" stopColor="#18D2EB"/>
            </linearGradient>
        </defs>
    </svg>
);

export const cta2 = (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M68 16H12C7.6 16 4 19.6 4 24V56C4 60.4 7.6 64 12 64H68C72.4 64 76 60.4 76 56V24C76 19.6 72.4 16 68 16ZM34.4 36L32.8 37.2C31.2 38.8 30.8 41.6 32 43.6L28.8 46.8L24.4 42.4L19.2 47.6C18.4 48.4 12.8 52.8 12 52C11.2 51.2 15.6 45.6 16.4 44.8L21.6 39.6L17.2 35.2L20.4 32C22.4 33.2 25.2 33.2 26.8 31.2L28 30C30 28 30 25.2 28.8 23.2L32 20L44 31.6L40.8 34.8C38.8 34 36 34 34.4 36V36ZM56 42L50 48L56 54V60L44 48L56 36V42ZM60 60V54L66 48L60 42V36L72 48L60 60Z" fill="url(#paint0_linear_2_4471)"/>
        <defs>
            <linearGradient id="paint0_linear_2_4471" x1="88.3333" y1="10" x2="-35" y2="83.3334" gradientUnits="userSpaceOnUse">
                <stop stopColor="#9D33DE"/>
                <stop offset="1" stopColor="#18D2EB"/>
            </linearGradient>
        </defs>
    </svg>
);

export const tableRow = (
    <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M79.8 8.40002V33.6H4.20001V8.40002H79.8ZM75.6 29.4V12.6H8.40001V29.4H75.6ZM21 16.8V25.2H12.6V16.8H21ZM33.6 16.8V25.2H25.2V16.8H33.6ZM46.2 16.8V25.2H37.8V16.8H46.2ZM58.8 16.8V25.2H50.4V16.8H58.8ZM71.4 16.8V25.2H63V16.8H71.4ZM79.8 37.8V75.6H4.20001V37.8H79.8ZM75.6 71.4V42H8.40001V71.4H75.6ZM21 46.2V54.6H12.6V46.2H21ZM33.6 46.2V54.6H25.2V46.2H33.6ZM46.2 46.2V54.6H37.8V46.2H46.2ZM71.4 46.2V54.6H50.4V46.2H71.4ZM46.2 58.8V67.2H12.6V58.8H46.2ZM58.8 58.8V67.2H50.4V58.8H58.8ZM71.4 58.8V67.2H63V58.8H71.4Z" fill="url(#paint0_linear_2_4373)"/>
        <defs>
            <linearGradient id="paint0_linear_2_4373" x1="113.75" y1="-22.7501" x2="-43.75" y2="112" gradientUnits="userSpaceOnUse">
                <stop stopColor="#9D33DE"/>
                <stop offset="1" stopColor="#18D2EB"/>
            </linearGradient>
        </defs>
    </svg>
);

export const buttons = (
    <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M60.9167 10.75H25.0834C21.1417 10.75 17.9167 13.975 17.9167 17.9167V32.25C17.9167 36.1917 21.1417 39.4167 25.0834 39.4167H60.9167C64.8584 39.4167 68.0834 36.1917 68.0834 32.25V17.9167C68.0834 13.975 64.8584 10.75 60.9167 10.75ZM62.7084 32.25C62.7084 33.325 61.9917 34.0417 60.9167 34.0417H25.0834C24.0084 34.0417 23.2917 33.325 23.2917 32.25V17.9167C23.2917 16.8417 24.0084 16.125 25.0834 16.125H60.9167C61.9917 16.125 62.7084 16.8417 62.7084 17.9167V32.25ZM34.0417 27.95H51.9584V22.2167H34.0417V27.95ZM60.9167 46.5833H25.0834C21.1417 46.5833 17.9167 49.8083 17.9167 53.75V68.0833C17.9167 72.025 21.1417 75.25 25.0834 75.25H60.9167C64.8584 75.25 68.0834 72.025 68.0834 68.0833V53.75C68.0834 49.8083 64.8584 46.5833 60.9167 46.5833ZM62.7084 68.0833C62.7084 69.1583 61.9917 69.875 60.9167 69.875H25.0834C24.0084 69.875 23.2917 69.1583 23.2917 68.0833V53.75C23.2917 52.675 24.0084 51.9583 25.0834 51.9583H60.9167C61.9917 51.9583 62.7084 52.675 62.7084 53.75V68.0833ZM34.0417 63.7833H51.9584V58.4083H34.0417V63.7833Z" fill="url(#paint0_linear_204_760)"/>
        <defs>
            <linearGradient id="paint0_linear_204_760" x1="43" y1="10.75" x2="43" y2="75.25" gradientUnits="userSpaceOnUse">
                <stop stopColor="#9D33DE"/>
                <stop offset="0.9999" stopColor="#18D2EB"/>
                <stop offset="1" stopOpacity="0"/>
                <stop offset="1" stopColor="#18D2EB"/>
            </linearGradient>
        </defs>
    </svg>
);
